'use client';

import banner from '@/assets/images/convention/influence/influencerbanner.jpg';
import banner_m from '@/assets/images/convention/influence/influencerbanner_m.png';
import pic1_1 from '@/assets/images/convention/influence/pic1-1.jpg';
import pic1_2 from '@/assets/images/convention/influence/pic1-2.jpg';
import pic1_3 from '@/assets/images/convention/influence/pic1-3.jpg';
import pic1_4 from '@/assets/images/convention/influence/pic1-4.jpg';
import pic2_1 from '@/assets/images/convention/influence/pic2-1.jpg';
import pic2_2 from '@/assets/images/convention/influence/pic2-2.jpg';
import pic2_3 from '@/assets/images/convention/influence/pic2-3.jpg';
import pic3_1 from '@/assets/images/convention/influence/pic3-1.jpg';
import pic3_2 from '@/assets/images/convention/influence/pic3-2.jpg';
import pic3_3 from '@/assets/images/convention/influence/pic3-3.jpg';
import Button from '@/components/Button';
import Checkbox from '@/components/Checkbox';
import Field from '@/components/Field';
import Select from '@/components/Select';
import TextInput from '@/components/TextInput';
import useIsMobile from '@/hooks/use-is-mobile';
import combine from '@/util/combineValidators';
import { isDynamicRequired, isRequired, isSelectAppType } from '@/util/formValidators';
import { Form } from 'informed';
import Image from 'next/image';
import { Fragment, useMemo } from 'react';
import classes from './influencerProgramPage.module.css';
import { useInfluencerProgramPage } from './useInfluencerProgramPage';

const options = [
  {
    label: 'Influence or Blogger',
    value: '0',
  },
  {
    label: 'Blog Website',
    value: '1',
  },
  {
    label: 'Photographer',
    value: '2',
  },
  {
    label: 'Wedding Planner',
    value: '3',
  },
  {
    label: 'Bride',
    value: '4',
  },
  {
    label: 'Bridal Party Member',
    value: '5',
  },
  {
    label: 'College Students',
    value: '6',
  },
  {
    label: 'AW Bridal Customer',
    value: '7',
  },
  {
    label: 'Other',
    value: '8',
  },
];

const InfluencerProgramPage = () => {
  const {
    formApiRef,
    step,
    nextStep,
    handleSubmit,
    isLoading,
    applicationType,
    selectType,
    response,
    customerType,
    setCustomerType,
  } = useInfluencerProgramPage({});

  const isMobile = useIsMobile();

  const step1content = (
    <div className={classes.content}>
      <h1 className={classes.contenttitle}>Influencer Policy</h1>

      <h4 className={classes.contentsubtitle}>Reward:</h4>
      <p>
        1. Earn a 3%~8% commission directly to your PayPal account! The more you sell, the higher the commission rate.
      </p>
      <p>2. Get a chance to receive free new style dresses.</p>
      <p>3. Receive a 15% off coupon when you reach $500 in sales!</p>
      <h4 className={classes.contentsubtitle}>Cooperation Details:</h4>
      <p>1. Once your application is accepted, you will receive a confirmation email.</p>
      <p>2. Put the promotional images we provide on your social platforms.</p>
      <p>
        3. Log in to your AW.Bridal account to share your referral link or code with your followers, friends, or others.
        If they log in with an existing account or register a new one, their account will be linked to yours.
      </p>
      <p>
        4. When customers use your referral link or code to place an order, you will receive a 3%~8% commission. You can
        check your commission in your account, and payments are processed via PayPal at the beginning of each month.
      </p>
      <p>
        5. For any questions, please contact us at{' '}
        <a
          href='mailto:social@awbridal.com'
          className='underline lg_hover_text-80583F'
        >
          social@awbridal.com
        </a>
        .
      </p>
    </div>
  );
  const step2content = (
    <div className={classes.content}>
      <h1 className={[classes.contenttitle, classes.content2title].join(' ')}>Promotion Image</h1>
      <h4 className={classes.content2subtitle}>Put our promotion image on the frontpage of your blog.</h4>
      <div className={classes.pic1}>
        <Image
          src={pic1_1}
          alt=''
        />
        <Image
          src={pic1_2}
          alt=''
        />
        <Image
          src={pic1_3}
          alt=''
        />
        <Image
          src={pic1_4}
          alt=''
        />
      </div>
      <div className={classes.pic2}>
        <Image
          src={pic2_1}
          alt=''
        />
        <Image
          src={pic2_2}
          alt=''
        />
        <Image
          src={pic2_3}
          alt=''
        />
      </div>
      <div className={classes.pic3}>
        <Image
          src={pic3_1}
          alt=''
        />
        <Image
          src={pic3_2}
          alt=''
        />
        <Image
          src={pic3_3}
          alt=''
        />
      </div>
    </div>
  );

  const maybeSuccessInfo = useMemo(() => {
    return response && response.code === '200' ? (
      <span className={classes.successInfo}>
        Your submition is successful. We will contact you if your application is accepted. Thank you!
      </span>
    ) : response && response.code === '500' ? (
      <span className={classes.msgerror}>{response.content}</span>
    ) : null;
  }, [response]);

  const otherCustomerTypeFieldClass = useMemo(() => {
    return customerType !== '8' ? classes.otherCustomerTypeHidden : classes.otherCustomerType;
  }, [customerType]);

  const otherCustomerTypeFieldProps = useMemo(() => {
    return customerType !== '8'
      ? {}
      : {
          required: true,
        };
  }, [customerType]);

  const otherCustomerTypeInputProps = useMemo(() => {
    return customerType !== '8'
      ? {
          validate: null,
        }
      : {
          validate: isRequired,
        };
  }, [customerType]);

  const step3content = useMemo(() => {
    return (
      <div className={classes.formcon}>
        <h1 className={classes.contenttitle}>Complete the form to apply</h1>
        <Form
          className={classes.form}
          onSubmit={handleSubmit}
          formApiRef={formApiRef}
        >
          <Field
            id='customerType'
            label={<span className='text-[15px]'>I&apos;m an/a...</span>}
            required
          >
            <Select
              items={options}
              initialValue={customerType}
              field='customerType'
              onChange={event => {
                setCustomerType(event.value);
              }}
            />
          </Field>
          <Field
            id='otherCustomerType'
            label={<span className='text-[15px]'>Please Specify</span>}
            classes={{
              root: otherCustomerTypeFieldClass,
            }}
            {...otherCustomerTypeFieldProps}
          >
            <TextInput
              autoComplete='otherCustomerType'
              field='otherCustomerType'
              id='otherCustomerType'
              {...otherCustomerTypeInputProps}
            />
          </Field>
          <Field
            id='first-name'
            label={<span className='text-[15px]'>First Name</span>}
            classes={{
              root: classes.firstname,
            }}
            required
          >
            <TextInput
              autoComplete='firstname'
              field='firstname'
              id='firstName'
              validate={isRequired}
            />
          </Field>
          <Field
            id='last-name'
            label={<span className='text-[15px]'>Last Name</span>}
            classes={{
              root: classes.lastname,
            }}
            required
          >
            <TextInput
              autoComplete='lastname'
              field='lastname'
              id='lastName'
              validate={isRequired}
            />
          </Field>
          <Field
            id='email'
            label={<span className='text-[15px]'>Email</span>}
            classes={{
              root: classes.email,
              label: classes.fieldlabel,
            }}
            required
          >
            <TextInput
              autoComplete='email'
              field='email'
              id='Email'
              validate={isRequired}
            />
          </Field>

          <div className={classes.type}>
            <label className={classes.typetitle}>Type</label>
            <Checkbox
              field=''
              label=''
              classes={{
                root: classes.apptype,
              }}
              validate={combine([[isSelectAppType, applicationType]])}
            />
            <div className={classes.typeInput}>
              <Checkbox
                field='instagram'
                label={<span className='text-[15px]'>Instagram</span>}
                filter={true}
                onChange={() => selectType('Instagram')}
              />
              <TextInput
                autoComplete='instagramurl'
                field='instagramurl'
                id='InstagramUrl'
                placeholder='Enter your instagram @name'
                validate={combine([[isDynamicRequired, ['Instagram', applicationType]]])}
                disabled={applicationType['Instagram']}
              />
            </div>

            <div className={classes.typeInput}>
              <Checkbox
                field='pinterest'
                label={<span className='text-[15px]'>Pinterest</span>}
                filter={true}
                onChange={() => selectType('Pinterest')}
              />
              <TextInput
                autoComplete='pinteresturl'
                field='pinteresturl'
                id='PinterestUrl'
                placeholder='Enter your pinterest url'
                validate={combine([[isDynamicRequired, ['Pinterest', applicationType]]])}
                disabled={applicationType['Pinterest']}
              />
            </div>

            <div className={classes.typeInput}>
              <Checkbox
                field='facebook'
                label={<span className='text-[15px]'>Facebook</span>}
                filter={true}
                onChange={() => selectType('Facebook')}
              />
              <TextInput
                autoComplete='facebookurl'
                field='facebookurl'
                id='FacebookUrl'
                placeholder='Enter your facebook url'
                validate={combine([[isDynamicRequired, ['Facebook', applicationType]]])}
                disabled={applicationType['Facebook']}
              />
            </div>

            <div className={classes.typeInput}>
              <Checkbox
                field='tiktok'
                label={<span className='text-[15px]'>Tik Tok</span>}
                filter={true}
                onChange={() => selectType('TikTok')}
              />
              <TextInput
                autoComplete='tiktokurl'
                field='tiktokurl'
                id='TiktokUrl'
                placeholder='Enter your Tik Tok @name'
                validate={combine([[isDynamicRequired, ['TikTok', applicationType]]])}
                disabled={applicationType['TikTok']}
              />
            </div>

            <div className={classes.typeInput}>
              <Checkbox
                field='youtube'
                label={<span className='text-[15px]'>Youtube</span>}
                filter={true}
                onChange={() => selectType('Youtube')}
              />
              <TextInput
                autoComplete='youtubeurl'
                field='youtubeurl'
                id='YoutubeUrl'
                placeholder='Enter your youtube url'
                validate={combine([[isDynamicRequired, ['Youtube', applicationType]]])}
                disabled={applicationType['Youtube']}
              />
            </div>

            <div className={classes.typeInput}>
              <Checkbox
                field='blog'
                label={<span className='text-[15px]'>Blog</span>}
                filter={true}
                onChange={() => selectType('Blog')}
              />
              <TextInput
                autoComplete='blogurl'
                field='blogurl'
                id='BlogUrl'
                placeholder='Enter your blog url'
                validate={combine([[isDynamicRequired, ['Blog', applicationType]]])}
                disabled={applicationType['Blog']}
              />
            </div>
          </div>
          <div className={classes.submitbtn}>
            <Button
              type='submit'
              className={classes.submitButton}
              disabled={!!isLoading}
            >
              {isLoading ? 'SUBMITTING...' : 'SUBMIT'}
            </Button>
          </div>
          {maybeSuccessInfo}
        </Form>
      </div>
    );
  }, [
    handleSubmit,
    customerType,
    otherCustomerTypeFieldClass,
    otherCustomerTypeFieldProps,
    otherCustomerTypeInputProps,
    applicationType,
    isLoading,
    maybeSuccessInfo,
    setCustomerType,
    selectType,
  ]);

  return (
    <Fragment>
      <div className={classes.root}>
        <img
          src={isMobile ? banner_m.src : banner.src}
          width='100%'
          alt=''
        />
        <h1 className={classes.title}>Become An AW Bridal Influencer!</h1>
        <h6 className={classes.subtitle}>
          AW.Bridal is dedicated to bringing joy to brides, bridesmaids, and all our customers.
        </h6>
        <h6 className={classes.subtitle}>
          Help us spread the happiness by sharing our products with more brides and bridesmaids. Apply now to join our
          influencer program!
        </h6>
        <div className={classes.step}>
          {isMobile ? (
            step == 1 ? (
              <p className={[classes.stepno, classes.activestep].join(' ')}>1</p>
            ) : step == 2 ? (
              <p className={[classes.stepno, classes.activestep].join(' ')}>2</p>
            ) : (
              <p className={[classes.stepno, classes.activestep].join(' ')}>3</p>
            )
          ) : (
            <>
              <p
                className={[
                  classes.stepno,
                  step == 1 || step == 2 || step == 3 ? classes.activestep : classes.unactivestep,
                ].join(' ')}
              >
                1
              </p>
              <span
                className={[classes.line, step == 2 || step == 3 ? classes.activesline : classes.unactiveline].join(
                  ' ',
                )}
              />
              <p
                className={[classes.stepno, step == 2 || step == 3 ? classes.activestep : classes.unactivestep].join(
                  ' ',
                )}
              >
                2
              </p>
              <span className={[classes.line, step == 3 ? classes.activesline : classes.unactiveline].join(' ')} />
              <p className={[classes.stepno, step == 3 ? classes.activestep : classes.unactivestep].join(' ')}>3</p>
            </>
          )}
        </div>
        <div className={classes.steptitle}>
          {isMobile ? (
            step == 1 ? (
              <p className={classes.activesteptitle}>Influencer Policy</p>
            ) : step == 2 ? (
              <p className={classes.activesteptitle}>Promotion Image</p>
            ) : (
              <p className={classes.activesteptitle}>Submit Application</p>
            )
          ) : (
            <>
              <p className={step == 1 || step == 2 || step == 3 ? classes.activesteptitle : null}>Influencer Policy</p>
              <span />
              <p className={step == 2 || step == 3 ? classes.activesteptitle : null}>Promotion Image</p>
              <span />
              <p className={step == 3 ? classes.activesteptitle : null}>Submit Application</p>
            </>
          )}
        </div>
        {step == 1 ? step1content : step == 2 ? step2content : step3content}
        {step == 1 ? (
          <button
            className={classes.joinus}
            onClick={() => nextStep(2)}
          >
            JOIN US
          </button>
        ) : null}
        {step == 2 ? (
          <button
            className={classes.joinus}
            onClick={() => nextStep(3)}
          >
            NEXT
          </button>
        ) : null}
      </div>
    </Fragment>
  );
};

export default InfluencerProgramPage;
